import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { isFeatureEnabled } from '../lib/flags';
import {
  PAYWALL_MODE,
  STRIPE_PUBLISHABLE_KEY,
  STRIPE_BUY_BTN_MONTHLY,
  STRIPE_BUY_BTN_ANNUAL,
  STRIPE_BUY_BTN_ARCHIVE,
  STRIPE_LINK_MONTHLY,
  STRIPE_LINK_ANNUAL,
  STRIPE_LINK_ARCHIVE,
} from '../lib/env';

const mask = (s: string | undefined) => (s ? `${s.slice(0, 8)}…${s.slice(-4)}` : 'unset');

const PaywallDebug: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const debugOn = params.get('debug') === '1' || params.get('debug') === 'true';

  const { user } = useSelector((s: RootState) => s.auth);
  const { plan } = useSelector((s: RootState) => s.subscription);

  if (!debugOn) {
    return (
      <div className="p-4 text-sm text-gray-600">
        Append <code>?debug=1</code> to view paywall debug info.
      </div>
    );
  }

  const useBuyButtons =
    isFeatureEnabled('USE_STRIPE_BUY_BUTTONS') || PAYWALL_MODE === 'BUY_BUTTONS';
  const usePaymentLinks = PAYWALL_MODE === 'PAYMENT_LINKS';
  const pk = STRIPE_PUBLISHABLE_KEY || '';

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-4">
      <h2 className="text-xl font-semibold">Paywall Debug</h2>
      <div className="rounded-lg border p-4 bg-white">
        <div className="text-sm">
          <div>
            <span className="font-semibold">Mode</span>:{' '}
            {useBuyButtons
              ? 'Buy Buttons'
              : usePaymentLinks
                ? 'Payment Links'
                : 'Checkout Sessions'}
          </div>
          <div>
            <span className="font-semibold">Publishable Key</span>: {mask(pk)}
          </div>
          {useBuyButtons && (
            <>
              <div className="mt-2 font-semibold">Buy Button IDs</div>
              <ul className="list-disc list-inside">
                <li>Monthly: {STRIPE_BUY_BTN_MONTHLY || 'unset'}</li>
                <li>Annual: {STRIPE_BUY_BTN_ANNUAL || 'unset'}</li>
                <li>Archive: {STRIPE_BUY_BTN_ARCHIVE || 'unset'}</li>
              </ul>
            </>
          )}
          {usePaymentLinks && (
            <>
              <div className="mt-2 font-semibold">Payment Links</div>
              <ul className="list-disc list-inside">
                <li>
                  Monthly: <code>{STRIPE_LINK_MONTHLY || 'unset'}</code>
                </li>
                <li>
                  Annual: <code>{STRIPE_LINK_ANNUAL || 'unset'}</code>
                </li>
                <li>
                  Archive: <code>{STRIPE_LINK_ARCHIVE || 'unset'}</code>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
      <div className="rounded-lg border p-4 bg-white">
        <div className="text-sm">
          <div className="font-semibold mb-1">Entitlements</div>
          <div>User: {user?.email || 'n/a'}</div>
          <div>Plan: {plan}</div>
        </div>
      </div>
    </div>
  );
};

export default PaywallDebug;
